import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Stakeholder } from "@/types";

export function useCreateAddStakeholder() {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const path = `companies/${currentCompanyId}/stakeholders`;
      const res = await guacHttpClient.post<
        Stakeholder,
        HttpResponse<Stakeholder>
      >(path);
      return res.data;
    },
    onSuccess: (newStakeholder) => {
      queryClient.setQueryData(
        ["stakeholders", currentCompanyId],
        (cachedData?: Stakeholder[]) => {
          if (!cachedData) return [newStakeholder];
          return [...cachedData, newStakeholder];
        },
      );

      void queryClient.invalidateQueries({
        queryKey: ["companies-summary"],
      });
    },
  });
}
